import {
	Table, Pagination
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	useDebounce
}from 'use-debounce'
import {
	reRegionActions
}from '../NRI/ReRegion/store/actions'
import {
	reConstructionCategoryActions
}from '../NRI/ReConstructionCategory/store/actions'
import {
	reConstructionMaterialPeriodPriceActions
}from './store/actions'
import {
	reConstructionMaterialActions
}from '../NRI/ReConstructionMaterial/store/actions'
import ModalActuallMaterialPrice from './show'
import moment from 'moment'
import AccountingPeriod from '../AccountingPeriod'
import LocalLoading from '../../components/Loading/Local'
import CustomFilters from '../../components/CustomFilters'
import {
	Resizable
}from 'react-resizable'
import './style.css'
import CryptoJS from "crypto-js"

const ResizableTitle = (props) => {
	const { onResize, width, render, ...restProps } = props

	if (!width)
		return <th { ...restProps } />

	return (
		<Resizable
			draggableOpts={ {
				enableUserSelectHack: false
			} }
			handle={
				(
					<span
						className="react-resizable-handle"
						onClick={ (e) => {
							e.stopPropagation()
						} }
					>
					</span>
				)
			}
			height={ 0 }
			width={ width }
			onResize={ onResize }
		>
			<th
				{ ...restProps }
				className="column"
			/>
		</Resizable>
	)
}

const ReConstructionMaterialPeriodPrices = () => {
	const [page, setPage] = useState(1)
	const [table, setTable] = useState([])
	const [count, setCount] = useState(0)
	const [accountingPeriod, setAccountingPeriod] = useState(null)
	const [accountPeriodDate, setAccountPeriodDate] = useState(null)
	const [filter, setFilter] = useState(null)
	const [notice, setNotice] = useState(null)
	const [materialId, setMaterialId] = useState(null)
	const [showModalVisible, setShowModalVisible] = useState(false)
	const dispatch = useDispatch()
	const pageSize = 10
	const [searchCategory, setSearchCategory] = useState(null)
	const [category] = useDebounce(searchCategory, 500)
	const [searchMaterials, setSearchMaterials] = useState(null)
	const [searchMaterialsValue] = useDebounce(searchMaterials, 300)
	const { list: constructionCategories } = useSelector(state => state.reConstructionCategoryReducer)
	const { list: regions } = useSelector(state => state.reRegionReducer)
	const { paged, isSending } = useSelector(state => state.reConstructionMaterialPeriodPriceReducer)
	const { list } = useSelector(state => state.reConstructionMaterialReducer)

	const getPaged = (values) => {
		dispatch(reConstructionMaterialPeriodPriceActions.getPaged(values))
	}

	const getCategories = (values) => {
		dispatch(reConstructionCategoryActions.getList(values))
	}
	const getMaterials = (values) => {
		dispatch(reConstructionMaterialActions.getList(values))
	}

	const startColumns = [
		{
			dataIndex : 'codeKKM',
			key       : 'codeKKM',
			title     : 'Код ККМ',
			render    : (code, record) => (<a onClick={ () => showOrgPrices(record.materialId) }>
				{ code }
			</a>),
			width: 200
		},
		{
			dataIndex : 'materialName',
			key       : 'materialName',
			title     : 'Наименование материала',
			width     : 600
		},
		{
			dataIndex : 'measurementUnitName',
			key       : 'measurementUnitName',
			title     : 'Единица измерения',
			width     : 150
		}
	]

	const [columns, setColumns] = useState(startColumns)

	const showOrgPrices = (values) => {
		setMaterialId(values)
		setShowModalVisible(true)
	}
	useEffect(() => {
		if (searchMaterialsValue?.trim()?.length > 1){
			getMaterials({
				name     : searchMaterialsValue.trim(),
				pageSize : 10,
				isActual : false
			})
		}
	}, [searchMaterialsValue])

	useEffect(() => {
		onPaginationChange(1)
	}, [accountingPeriod])

	useEffect(() => {
		dispatch(reRegionActions.getList())
		return () => {
			dispatch(reConstructionMaterialActions.clear())
			dispatch(reRegionActions.clear())
			dispatch(reConstructionCategoryActions.clear())
		}
	}, [])

	const onPaginationChange = (value) => {
		accountingPeriod
			? (
				setPage(value),
				getPaged({
					materialName : filter?.materialName,
					categoryId   : filter?.categoryId,
					regions      : filter?.regions,
					page         : value,
					pageSize     : pageSize,
					periodId     : accountingPeriod
				})
			)
			: null
	}

	useEffect(() => {
		onPaginationChange(1)
	}, [filter])

	useEffect(() => {
		if (category?.length > 0){
			getCategories({
				name     : category,
				isAll    : true,
				pageSize : pageSize
			})
		}
	}, [category])

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	function decrypt(text, key){
		const keyHex = CryptoJS.enc.Utf8.parse(key)
		const decrypted = CryptoJS.DES.decrypt({
			ciphertext: CryptoJS.enc.Base64.parse(text)
		}, keyHex, {
			mode    : CryptoJS.mode.ECB,
			padding : CryptoJS.pad.Pkcs7
		})
		return decrypted.toString(CryptoJS.enc.Utf8)
	}

	const addRegions = () => {
		const regionsPrice = filter?.regions.sort((first, second) => first - second).map((val, i) => {
			const tempRegion = regions.find((elem) => elem.id == val)
			return (
				{
					className : 'blue-number',
					dataIndex : `region${ i }`,
					key       : tempRegion.id,
					title     : tempRegion.name,
					render    : (text, obj) => {
						const price = obj.regionPrices?.find(x => x.regionId == val)?.price
						return price ? decrypt(price, "from_evg") : null
					}
				}
			)
		})
		return (regionsPrice)
	}

	useEffect(() => {
		if (filter?.regions?.length){
			setColumns(startColumns.concat({
				key      : 'republicPriceDate',
				title    : `Цены без НДС на ${ table[0]?.periodDate || moment(accountPeriodDate)?.format("DD.MM.YYYY") || "отчётный период" }`,
				children : [...addRegions()],
				width    : 400
			}))
		}
		else {
			setColumns(startColumns.concat({
				key      : 'republicPriceDate',
				title    : `Цены без НДС на ${ table[0]?.periodDate || moment(accountPeriodDate)?.format("DD.MM.YYYY") || "отчётный период" }`,
				children : [
					{
						className : 'blue-number',
						dataIndex : 'republicPrice',
						key       : 'republicPrice',
						title     : 'Цена по стране',
						width     : 400,
						render    : (price) => {
							return price ? decrypt(price, "from_evg") : null
						}
					}
				]
			}))
		}
	}, [filter?.regions, table])

	const mergeColumns = columns.map((col, index) => ({
		...col,
		onHeaderCell: (column) => ({
			width    : column.width,
			onResize : handleResize(index)
		})
	}))

	const handleResize =
		(index) => (obj, { size }) => {
			const newColumns = [...columns]
			newColumns[index] = { ...newColumns[index],
				width: size.width }
			setColumns(newColumns)
		}

	return (
		<div id="page-base-prices">
			<div className="select-page">
				<h1 style={ { textAlign: "center" } }>
					База текущих цен на материалы для строительства
				</h1>
				<AccountingPeriod
					isBase
					accountingPeriod={ accountingPeriod }
					allowYearPickerClear={ false }
					setAccountingPeriod={ setAccountingPeriod }
					setAccountPeriodDate={ setAccountPeriodDate }
					setNotice={ setNotice }
				/>
				{
					Boolean(notice?.trim()) && (
						<h4>
							{ `Примечание к ценам данного отчётного периода: ${ notice.trim() }` }
						</h4>
					)
				}
				{ Boolean(accountingPeriod) && (
					<>
						<CustomFilters
							elements={ [
								{
									name        : "materialName",
									type        : "autoComplete",
									placeholder : "Введите название/код строительного материала",
									items       : list.map(item => ({ name      : `${ item.codeKKM } ${ item.name }`,
										isDeleted : item.isDeleted })),
									onSearch: (value) => setSearchMaterials(value)
								},
								{
									name        : "categoryId",
									type        : "select",
									placeholder : "Выберите группу кода материала",
									onSearch    : (value) => setSearchCategory(value),
									items       : constructionCategories,
									itemName    : ["codeKKM", "name"]
								},
								{
									name        : "regions",
									type        : "select",
									multiple    : true,
									placeholder : "Выберите регионы реализации материала",
									items       : regions,
									itemName    : ["name"]
								}
							] }
							setFilters={ setFilter }
						/>
						<Table
							columns={ mergeColumns }
							components={ {
								header: {
									cell: ResizableTitle
								}
							} }
							dataSource={ table }
							id="base-price-table"
							loading={ { indicator : <LocalLoading />,
								spinning  : isSending } }
							oncopy="return false;"
							pagination={ false }
							scroll={ { x: 1400 } }
							style={ { paddingBottom: "20px" } }
						/>
						{ count > pageSize
							? (
								<Pagination
									showQuickJumper
									current={ page }
									pageSize={ pageSize }
									showSizeChanger={ false }
									size="small"
									total={ count }
									onChange={ onPaginationChange }
								/>)
							: null }
					</>) }
			</div>
			<ModalActuallMaterialPrice
				materialId={ materialId }
				regions={ regions }
				setVisible={ setShowModalVisible }
				visible={ showModalVisible }
			/>
		</div>
	)
}

export default ReConstructionMaterialPeriodPrices